import { useState } from 'react';
import { ISLAND_OPTIONS, ABROAD } from '../data/maldivesIslands.ts';
import { dv } from '../i18n/dv.ts';

/**
 * Type-to-search picker for the resident "Moved to" field. As the user types,
 * matching Maldives islands (across all atolls) appear; "Abroad" is always
 * offered. Selecting one stores the full "Island (Atoll)" string (or "Abroad").
 * A reliable custom combobox (works on mobile, unlike a native <datalist>).
 */
export function IslandPicker({ value, onChange }: { value: string; onChange: (v: string) => void }): JSX.Element {
  const [open, setOpen] = useState(false);
  const q = value.trim().toLowerCase();
  const islandMatches = q.length >= 1 ? ISLAND_OPTIONS.filter((o) => o.toLowerCase().includes(q)).slice(0, 40) : [];
  const showAbroad = q.length === 0 || ABROAD.toLowerCase().includes(q);
  const matches = [...(showAbroad ? [ABROAD] : []), ...islandMatches];

  return (
    <div className="relative">
      <input
        className="input"
        value={value}
        placeholder={dv.register.movedToPlaceholder}
        autoComplete="off"
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
      />
      {open && matches.length > 0 && (
        <ul className="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-lg border border-border bg-paper shadow-lg">
          {matches.map((m) => (
            <li key={m}>
              <button
                type="button"
                className="block w-full px-3 py-2 text-start text-sm hover:bg-muted/60"
                onMouseDown={(e) => { e.preventDefault(); onChange(m); setOpen(false); }}
              >
                {m}
              </button>
            </li>
          ))}
        </ul>
      )}
      {open && q.length >= 1 && matches.length === 0 && (
        <p className="mono-meta absolute mt-1 px-1 text-muted-foreground">{dv.dhaftharu.noResults}</p>
      )}
    </div>
  );
}
